import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from "@angular/material/select";
import { Store } from "@ngrx/store";
import { firstValueFrom, Observable } from "rxjs";
import { AppState } from "../../../../app.state";
import {
  IInfoVobo,
  IPorSeleccion,
  RImprimirEmpresa,
} from "../../../../interfaces/despacho";
import { DespachoService } from "../../../../services/despacho/despacho.service";
import {
  selectDespachosEmpresas,
  selectTemasParaImpresion,
} from "../../../../states/despacho/selector";
import { ConfirmDialogComponent } from "../../../../confirm-dialog/confirm-dialog.component";
import { LoadingService } from "../../../../loading/loading.service";

@Component({
  selector: "app-confirm-dialog",
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: "./imprimir-dialog.component.html",
  styleUrl: "./imprimir-dialog.component.css",
})
export class ImprimirDialogComponent {
  public despachos$!: Observable<any[]>;
  public temasParaImpresion$!: Observable<IPorSeleccion>;
  public temasParaImpresion!: IPorSeleccion;
  public tipoImpresion!: IInfoVobo;
  public empresa!: RImprimirEmpresa | undefined;
  public tiposImpresion = [
    {
      id_tipo_despacho: 1,
      type: "Informativo",
    },
    {
      id_tipo_despacho: 2,
      type: "VoBo",
    },
    {
      id_tipo_despacho: 3,
      type: "Por Empresa",
    },
    {
      id_tipo_despacho: 4,
      type: "Por Selección",
    },
  ];
  formImprimir!: FormGroup;

  constructor(
    private store: Store<AppState>,
    public dialogRef: MatDialogRef<ImprimirDialogComponent>,
    public despachoService: DespachoService,
    public dialog: MatDialog,
    public loadingService: LoadingService,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {}
  ngOnInit() {
    console.log("data ImprimirDialogComponent", this.data);

    this.formImprimir = this.fb.group({
      tipoImpresion: ["", [Validators.required]],
      empresa: ["", [Validators.required]],
    });

    this.despachos$ = this.store.select(selectDespachosEmpresas).pipe();
    this.temasParaImpresion$ = this.store
      .select(selectTemasParaImpresion)
      .pipe();
    this.temasParaImpresion$.subscribe((temasParaImpresion) => {
      this.temasParaImpresion = temasParaImpresion;
    });
  }
  confirm(): void {
    this.imprimir();
  }

  async imprimir() {
    this.loadingService.show();
    
    console.log("imprimir", this.formImprimir.get("tipoImpresion")?.value);

    switch (this.formImprimir.get("tipoImpresion")?.value.id_tipo_despacho) {
      case 1:
      case 2:
        var data = await firstValueFrom(this.despachoService.getExcelInfoVobo(this.formImprimir.get("tipoImpresion")?.value));
        if (!data.error) {
          this.download(data);
        } else {
          this.openModalError("Error", data.message);
        }
        break;
      case 3:
        var data = await firstValueFrom(this.despachoService.getExcelEmpresa(this.empresa));
        if (!data.error) {
          this.download(data);
        } else {
          this.openModalError("Error", data.message);
        }
        break;
      case 4:
        const todosTemas: any[] = Object.values(this.data.value).flatMap(
          (despacho: any) => [...despacho.informativo, ...despacho.vobo]
        );
        const temasImpresion = this.despachoService.getImpresion();
        const temasParaImpresion = todosTemas
          .filter((tema) => temasImpresion.includes(tema.id_tema))
          .map((tema) => ({
            nombreTema: tema.nombreTema,
            nombre_empresa: (tema.id_empresa == 'otro' || tema.nombre_empresa == '-')? 'Otro' : tema.nombre_empresa,
            tipo_despacho: tema.descripcion,
          }));
        
        if (temasParaImpresion.length <= 0) {
          this.openModalError("Error", "No ha seleccionado temas a imprimir.");
          return;
        }

        var data = await firstValueFrom(this.despachoService.getExcelSeleccion({ toPrint: temasParaImpresion }));
        if (!data.error) {
          this.download(data);
        } else {
          this.openModalError("Error", data.message);
        }
        break;
      default:
        break;
    }
  }

  reset() {
    if (
      this.formImprimir.get("tipoImpresion")?.value &&
      this.formImprimir.get("tipoImpresion")?.value.id_tipo_despacho !== 3
    ) {
      this.empresa = undefined;
    }
  }

  openModalError(title: string, message: string): void {
    this.loadingService.hide();
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "500px",
      data: {
        title,
        message,
        showButtons: {
          accept: true,
          cancel: false,
        },
        direction: "end",
        buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
      },
    });

    dialogRef.componentInstance.confirmAction.subscribe(() => {});

    dialogRef.componentInstance.cancelAction.subscribe(() => {});
  }

  download(data: BlobPart) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    let fileName = `Listado de despacho ${
      this.formImprimir.get("tipoImpresion")?.value.type
    }.xlsx`;
    var link = document.createElement("a");

    link.id = this.formImprimir.get("tipoImpresion")?.value.type;
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    this.loadingService.hide();
    // Revocar el objeto URL y eliminar el elemento por clase
    setTimeout(() => {
      window.URL.revokeObjectURL(link.href);
      const elements = document.getElementById(
        this.formImprimir.get("tipoImpresion")?.value.type
      );
      elements?.remove();
    }, 2000);
  }
}
